import React from "react";
import { Link, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EmailTemplateBasicDetail from "./emailTemplateComponents/EmailTemplateBasicDetail";

import { useGetEmailTemplateDetailQuery } from "store/services/emailTemplateApi";

import { useAppMeta } from "hooks";
import ToggleEmailTemplateStatus from "./emailTemplateComponents/ToggleEmailTemplateStatus";

const breadcrumbs = [
  { title: "Email Templates", path: "/app/crm/email-template/list" },
  {
    title: "Email Template Detail",
  },
];

const EmailTemplateDetailScreen = () => {
  const { id } = useParams();

  // RTK Query
  const {
    data: emailTemplateDetail,
    isLoading: loadingEmailTemplate,
    isFetching: fetchingEmailTemplate,
    error,
  } = useGetEmailTemplateDetailQuery(id);

  const isBusy = loadingEmailTemplate || fetchingEmailTemplate;

  useAppMeta(
    !emailTemplateDetail
      ? "EmailTemplate Detail"
      : `EmailTemplate - ${emailTemplateDetail?.status}`
  );

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={isBusy}
      headerActions={<PageActions emailTemplateId={emailTemplateDetail?._id} emailTemplateDetail={emailTemplateDetail} />}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <EmailTemplateBasicDetail
          emailTemplateDetail={emailTemplateDetail}
          loadingEmailTemplate={isBusy}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EmailTemplateDetailScreen;

const PageActions = ({ emailTemplateId, emailTemplateDetail }) => {
  return (
    <div className="flex gap-4">
      <ToggleEmailTemplateStatus emailTemplateDetail={emailTemplateDetail} />

      <Link to={`/app/crm/email-template/${emailTemplateId}/edit`}>
        <Button variant="contained" startIcon={<EditOutlined />}>
          Edit
        </Button>
      </Link>
    </div>
  );
};
